import { Search, SlidersHorizontal } from 'lucide-react'
import { PageHeader } from '../../components/ui/PageHeader'

const ROWS = 7
// Varied widths so the rows read as names and places, not a grid of bars.
const NAME_WIDTHS = ['62%', '48%', '71%', '55%', '66%', '44%', '58%']

const Bar = ({ width, tall = false }: { width: string; tall?: boolean }) => (
  <span className={`skeleton-bar${tall ? ' is-tall' : ''}`} style={{ width }} />
)

/**
 * The Leads page waiting for its data. Built from the real toolbar, header
 * and row classes so the loaded page lands in the same geometry.
 */
export function LeadsSkeleton() {
  return (
    <div aria-busy="true" className="page leads-page leads-skeleton">
      <PageHeader
        title="Leads"
        description="Companies and their associated owners, combined in one working view."
      />
      <span className="sr-only" role="status">Loading leads from the live sheet</span>
      <div aria-hidden="true">
        <div className="leads-toolbar">
          <div className="leads-toolbar-row">
            <span className="search-field">
              <Search size={18} />
              <Bar width="46%" />
            </span>
            <span className="filter-trigger">
              <SlidersHorizontal size={16} strokeWidth={1.9} />
              Filter
            </span>
          </div>
        </div>
        <div className="results-summary"><Bar width="220px" /></div>

        <div className="lead-table-wrap">
          <div className="lead-table">
            <div className="lead-table-header">
              <span>Lead</span>
              <span>Priority</span>
              <span>Stage</span>
              <span>Account manager</span>
              <span>Location</span>
              <span>Contact</span>
            </div>
            <div className="lead-table-body">
              {NAME_WIDTHS.slice(0, ROWS).map((width, row) => (
                <div className="lead-card-row is-skeleton" key={row}>
                  <div className="lead-grid-cell">
                    <div className="lead-company-cell">
                      <span className="skeleton-logo" />
                      <div className="lead-company-copy skeleton-stack">
                        <Bar tall width={width} />
                        <Bar width="38%" />
                      </div>
                    </div>
                  </div>
                  <div className="lead-grid-cell"><Bar width="28px" /></div>
                  <div className="lead-grid-cell"><Bar width="72%" /></div>
                  <div className="lead-grid-cell"><Bar width="64%" /></div>
                  <div className="lead-grid-cell"><Bar width="58%" /></div>
                  <div className="lead-grid-cell"><Bar width="70%" /></div>
                </div>
              ))}
            </div>
          </div>
        </div>

        <ul className="mobile-lead-list">
          {NAME_WIDTHS.slice(0, 5).map((width, row) => (
            <li key={row}>
              <div className="mobile-lead-row is-skeleton">
                <span className="mobile-lead-identity">
                  <span className="skeleton-logo" />
                  <span className="mobile-lead-main skeleton-stack">
                    <Bar tall width={width} />
                    <Bar width="42%" />
                    <Bar width="30%" />
                  </span>
                </span>
              </div>
            </li>
          ))}
        </ul>
      </div>
    </div>
  )
}
